/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_NEXT_PREV_LARGE': {
    width: 16,
    height: 16,
    viewBox: '0 0 31 59',
    data: '<path pid="0" _fill="#545454" d="M30.9 29.5L1.51.11.1 1.52 28.07 29.5.1 57.48l1.41 1.41L30.9 29.5z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_NEXT_PREV_LARGE.js